import { render, staticRenderFns } from "./IconGiftSolid.vue?vue&type=template&id=b8900d22"
import script from "./IconGiftSolid.vue?vue&type=script&lang=js"
export * from "./IconGiftSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports